import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useSession } from '@/auth/client'
import { Loading } from '@/components/state/Loading'

/**
 * A raiz não é tela nenhuma: ela olha a sessão e manda cada um para a sua
 * porta. Quem não tem sessão vai para a entrada do paciente, que é o lado
 * de quem chega por link. A terapeuta chega por `/app/entrar`, e o Guard de
 * `/app` a manda para lá sozinho.
 */
export const Route = createFileRoute('/')({
  component: function Raiz() {
    const { data, isPending } = useSession()
    if (isPending) return <Loading label="Conferindo a sessão" rows={1} />

    const papel = (data?.user as { role?: unknown } | undefined)?.role
    if (papel === 'therapist') return <Navigate to="/app" replace />
    if (papel === 'patient') return <Navigate to="/portal" replace />
    return <Navigate to="/portal/entrar" replace />
  },
})
